/**
 * Models the result of checking for a daemon update.
 */
export default class MoneroDaemonUpdateCheckResult {
    constructor(result) {
        Object.assign(this, result);
    }
    /**
     * Indicates if an update is available.
     *
     * @return {boolean} true if an update is available, false otherwise
     */
    getIsUpdateAvailable() {
        return this.isUpdateAvailable;
    }
    setIsUpdateAvailable(isUpdateAvailable) {
        this.isUpdateAvailable = isUpdateAvailable;
        return this;
    }
    /**
     * Get the update's version.
     *
     * @return {string} is the update's version
     */
    getVersion() {
        return this.version;
    }
    setVersion(version) {
        this.version = version;
        return this;
    }
    /**
     * Get the update's hash.
     *
     * @return {string} is the update's hash
     */
    getHash() {
        return this.hash;
    }
    setHash(hash) {
        this.hash = hash;
        return this;
    }
    /**
     * Get the uri to automatically download the update.
     *
     * @return {string} is the uri to automatically download the update
     */
    getAutoUri() {
        return this.autoUri;
    }
    setAutoUri(autoUri) {
        this.autoUri = autoUri;
        return this;
    }
    /**
     * Get the uri to manually download the update.
     *
     * @return {string} is the uri to manually download the update
     */
    getUserUri() {
        return this.userUri;
    }
    setUserUri(userUri) {
        this.userUri = userUri;
        return this;
    }
}
